<template>
	<div>
		<egranty-autocomplete-multi
			:is-visible="addAccreditationCountryVisible"
			:possibilities="possibleCountries"
			:headers="possibleCountriesHeaders"
			@cancel="addAccreditationCountryVisible = false"
			@save="(country) => {addAccreditationCountry(country)}"
			title="Dodaj kraj"
			search-field-label="Nazwa kraju"
			hint=""
		></egranty-autocomplete-multi>
		<egranty-autocomplete-multi
			:is-visible="copyAccreditationCountryVisible"
			:possibilities="possibleCountries"
			:headers="possibleCountriesHeaders"
			@cancel="copyAccreditationCountryVisible = false"
			@save="(country) => {copyAccreditationCountries(country)}"
			title="Wklej kraj"
			search-field-label="Nazwa kraju"
			hint="Priorytety i obszary przypisane do kopiowanego kraju zostaną powielone dla wskazanych krajów"
		></egranty-autocomplete-multi>
		<egranty-input-field-popup
			:defaultValue="active[0].name"
			:is-open.sync="renamePopupVisible"
			label="Nowa nazwa"
			for="contest-tasks-task-tab-new-name"
			id="contest-tasks-task-tab-new-name"
			title="Zmień nazwę zadania"
			long
			@save="renameTask"
		></egranty-input-field-popup>

		<v-toolbar color="blue">
			<v-toolbar-title>Zadanie ({{active[0].name}})</v-toolbar-title>
		</v-toolbar>

		<v-container style="padding: 12px;">
			<div>
				<v-btn @click="addAccreditationCountryVisible= true"> Dodaj kraj</v-btn>
				<v-btn @click="duplicateTask(active[0].id)"> Utwórz duplikat</v-btn>
			</div>
			<div>
				<v-btn v-if="!disablePasteCountryButton" @click="pasteCountry()"> Wklej kraj</v-btn>
			</div>
			<div>
				<v-btn
					color="lightred"
					:disabled="disabled"
					@click="deleteTask(active[0].id)"> Usuń
				</v-btn>
				<v-btn @click="putTaskHigher">
					<v-icon color="white">arrow_upward</v-icon>
				</v-btn>
				<v-btn @click="putTaskLower">
					<v-icon color="white">arrow_downward</v-icon>
				</v-btn>
				<v-btn
					:disabled="disabled"
					@click="renamePopupVisible= true"> Zmień nazwę
				</v-btn>
			</div>
		</v-container>
	</div>
</template>
<script>
	import {Task} from "../../../../api/generated/Task";
	import EgrantyAutocompleteMulti from "../../../../genericComponents/EgrantyAutocompleteMulti";
	import EgrantyInputFieldPopup from "../../../../genericComponents/EgrantyInputFieldPopup";

	export default {
		name: "TaskTab",
		components: {EgrantyInputFieldPopup, EgrantyAutocompleteMulti},
		computed:{
			disablePasteCountryButton(){
				if(!this.copiedObject){
					return true;
				}
				if(!this.copiedObject.type || !this.copiedObject.id){
					return true;
				}
				if(this.copiedObject.type != "country"){
					return true;
				}
				if(this.copiedObject.id == this.active[0].id){
					return true;
				}
				if(this.copiedObject.onlyChildNodes){
					return true;
				}
				return false;
			}
		},
		methods: {
			getContestId() {
				return this.$route.params.id;
			},

			refreshAccreditationCountries() {
				Task.getCountriesToAdd(this, this.active[0].id,  (successResponse) => {
					this.possibleCountries = successResponse;
				});
			},

			renameTask(newName) {
				Task.postRenameTask(
					this,
					this.active[0].id,
					newName,
					() => {
						this.$emit("refresh");
					}, errorResponse => {
					if (errorResponse.status === "NOT_ACCEPTABLE") {
						this.$emit("displayRenameErrorDialog", errorResponse);
					}});
			},

			addAccreditationCountry(country) {
				let countriesIds = country.map(x=>x.id);
				Task.putTaskAccreditationCountries(this, this.active[0].id, countriesIds, () => {
						this.$emit("refresh");
					},
					(errorResponse) => {
						this.$messagesBus.$emit("error", errorResponse.message);
					},
				);
				this.addAccreditationCountryVisible = false;
			},

			copyAccreditationCountries(countries){
				let countriesIds = countries.map(x=>x.id); // lista krajów którą kopiujemy do zadania
				Task.postCopyTaskCountries(this, this.active[0].id, this.copiedObject.id, countriesIds, () => {
						this.$emit("refresh");
					},
					(errorResponse) => {
						this.$messagesBus.$emit("error", errorResponse.message);
					},
				);
			},

			putTaskHigher() {
				Task.postTaskHigherInView(
					this,
					this.active[0].id,
					() => this.$emit("refresh"),
				);
			},

			putTaskLower() {
				Task.postTaskLowerInView(
					this,
					this.active[0].id,
					() => this.$emit("refresh"),
				);
			},

			deleteTask(taskId) {
				Task.deleteTask(this, taskId, () => {
					this.$emit("refresh");
				}, errorResponse => {
					if (errorResponse.status === "NOT_ACCEPTABLE") {
						this.$emit("removalError", errorResponse);
					}
				});
			},
			duplicateTask(taskId){
				Task.postTaskDuplicate(this, taskId, () => {
					this.$emit("refresh");
				}, errorResponse => {
					if (errorResponse.status === "NOT_ACCEPTABLE") {
						this.$emit("duplicateError", errorResponse);
					}
				});
			},
			pasteCountry(){
				this.copyAccreditationCountryVisible = true;
			},

		}
		,

		mounted() {
			this.refreshAccreditationCountries();
		}
		,

		data() {
			return {
				renamePopupVisible: false,
				addAccreditationCountryVisible: false,
				copyAccreditationCountryVisible: false,
				possibleCountries: [],
				possibleCountriesHeaders: {name: "nazwa"},
				taskRemovingErrors: {
					showPopup: false,
					messages: [],
				}
			};
		}
		,

		props: {
			active: {},
			disabled: {type: Boolean, default: false},
			copiedObject: {
				type: Object,
				default: function () {
					return {};
				},
			}
		},
	};
</script>
